import useTestId from '@ori/testid-generator';
import { isNonNullable } from '@ori/ts-utils';
import { InfoCircle } from '@ori-ui/icons';
import { Root } from "./styles";
import { LOWEST_PREVIOUS_PRICE } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LowestPreviousPrice = function LowestPreviousPrice(_ref) {
  var className = _ref.className,
    priceWithCurrency = _ref.priceWithCurrency,
    text = _ref.text;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  return isNonNullable(priceWithCurrency) && priceWithCurrency !== '' ? /*#__PURE__*/_jsxs(Root, {
    className: className,
    "data-testid": getTestId(LOWEST_PREVIOUS_PRICE),
    children: [/*#__PURE__*/_jsx(InfoCircle, {}), text, " ", priceWithCurrency]
  }) : null;
};
//# sourceMappingURL=LowestPreviousPrice.js.map